import { PayloadAction } from '@reduxjs/toolkit';
import { ProjectsReducerCreator } from '../types';

const setShowCreateGroupModalReducer = (create: ProjectsReducerCreator) => {
  return create.reducer((state, action: PayloadAction<boolean>) => {
    state.showCreateGroupModal = action.payload;
  });
};

export default setShowCreateGroupModalReducer;
